import {AccountCircle} from "@mui/icons-material";
import {AppBar, Avatar, IconButton, Menu, MenuItem, Toolbar, Typography} from "@mui/material";
import {Box} from "@mui/system";
import {useContext, useState} from "react";
import {useNavigate} from "react-router";
import {useAuth} from "../../firebase/firebaseAuth";
import {SecurityRole} from "../../models/UserData";
import logo from '../../images/logo_white.png';
import {useTranslation} from "react-i18next";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {useLocation} from "react-router-dom";
import LanguageIcon from '@mui/icons-material/Language';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {I18Context, Languages, LanguagesType} from "../../i18nProvider";
import i18n from "i18next";

export const AppBarComponent = () => {
  const {t} = useTranslation();
  const {changeLanguage} = useContext(I18Context);
  const location = useLocation()
  const {signOut, userData, user} = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorElI18, setAnchorElI18] = useState<null | HTMLElement>(null);
  const navigate = useNavigate()
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorElI18(null);
  };

  const handleI18Menu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElI18(event.currentTarget);
  }


  const changeLan = (language: LanguagesType) => {
    changeLanguage(language);
    handleClose();
  }

  return (
    <AppBar position="static">
      <Toolbar>
        {location.pathname !== "/" &&
            <IconButton onClick={() => navigate("/")}><ArrowBackIcon color="secondary"/></IconButton>}
        <img src={logo} height="25px" alt={t('logo') || " "} onClick={() => navigate("/")}/>
        <Box sx={{flexGrow: 1}}/>
        <Box sx={{display: 'flex', alignItems: 'center'}} onClick={handleI18Menu}>
          <LanguageIcon/>
          <Typography>{t(`user.${i18n.language}_short`)||"EN"}</Typography>
          <ExpandMoreIcon/>
        </Box>
        <Menu
          id="menu-appbar"
          anchorEl={anchorElI18}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorElI18)}
          onClose={handleClose}
        >
          {Languages.map(language => (
            <MenuItem key={language} value={language} onClick={() => changeLan(language)}>
              <Box display={'flex'} alignItems={'center'} flexWrap={'wrap'} gap={2}>
                <LanguageIcon fontSize={"small"}/>
                {t(`user.${language}_short`)}
              </Box>
            </MenuItem>
          ))}
        </Menu>
        {user &&
            <div>
                <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleMenu}
                    color="inherit"
                    edge="end"
                >
                  {user?.photoURL && <Avatar alt="USER" src={user.photoURL}/>}
                  {!user?.photoURL &&
                      <AccountCircle/>
                  }
                </IconButton>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem color="secondary"
                              onClick={() => navigate("/user-details")}>{t('appbar.myData')}</MenuItem>
                    <MenuItem color="secondary" onClick={signOut}>{t('appbar.logOut')}</MenuItem>
                  {userData?.security_role === SecurityRole.ADMIN &&
                      <MenuItem onClick={() => navigate("/admin")}>Admin</MenuItem>}
                </Menu>
            </div>
        }
      </Toolbar>
    </AppBar>
  )
}